import { AnyAction } from '@reduxjs/toolkit';
import { Map } from 'leaflet';
import { Dispatch } from 'react';
import { setCurrentRotationAmount } from '../../../../../app/redux/slices/currentRotationAmountSlice';

export const rotationControlEvents = (map: Map, dispatch: Dispatch<AnyAction>) => {
    map.on('rotate', (event: any) => {
        dispatch(setCurrentRotationAmount(event.target._bearing));
    });
};
